import { EntityDetailsSimpleItem } from '../../../../../../ui/components/EntitySectionList';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { formatPhoneNumber } from '@juvare/common-phone-number';
import TextSmsDisabledOutlinedIcon from '@juvare/common-web-ui/icons/TextSmsDisabledOutlined';
import FaxOutlinedIcon from '@mui/icons-material/FaxOutlined';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useSelector } from 'react-redux';
export const AccountPhoneNumber = (props) => {
    const { contactPhoneNumber, phoneConsents, label, showLabel, typographyVariant, iconColor } = props;
    const { t } = useContactManagementTranslation();
    const settings = useSelector(getSettings);
    const phoneConsentStatus = phoneConsents.find((consent) => consent.columns.phoneNumber === contactPhoneNumber.phoneNumber);
    const showPhoneNumberStatus = (!settings.useConsentlessTexting && !!phoneConsentStatus) ||
        (settings.useConsentlessTexting && (phoneConsentStatus === null || phoneConsentStatus === void 0 ? void 0 : phoneConsentStatus.columns.status) === 'canceled');
    let statusTooltipMessage;
    if (showPhoneNumberStatus) {
        statusTooltipMessage = t('panels.accounts.statusAndMessage', {
            status: phoneConsentStatus.columns.status,
            message: phoneConsentStatus.columns.message,
        });
    }
    else {
        statusTooltipMessage = t('panels.accounts.textConsentDetailsUnavailable');
    }
    let textIcon;
    if (contactPhoneNumber.type.text) {
        textIcon =
            (phoneConsentStatus === null || phoneConsentStatus === void 0 ? void 0 : phoneConsentStatus.columns.status) === 'confirmed' ||
                (settings.useConsentlessTexting && (phoneConsentStatus === null || phoneConsentStatus === void 0 ? void 0 : phoneConsentStatus.columns.status) !== 'canceled') ? (React.createElement(SmsOutlinedIcon, { fontSize: 'small', sx: { color: iconColor, mr: 1 } })) : (React.createElement(TextSmsDisabledOutlinedIcon, { fontSize: 'small', sx: { color: iconColor, mr: 1 } }));
    }
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' }, "data-test": props['data-test'] },
        React.createElement(EntityDetailsSimpleItem, { showLabel: showLabel, label: label, labelWidth: 80, text: formatPhoneNumber(contactPhoneNumber.phoneNumber), textMaxWidth: 144, marginBottom: 0, typographyVariant: typographyVariant }),
        contactPhoneNumber.type.voice && React.createElement(PhoneEnabledOutlinedIcon, { fontSize: 'small', sx: { color: iconColor, mr: 1 } }),
        textIcon && (React.createElement(Tooltip, { title: statusTooltipMessage, disableHoverListener: !showPhoneNumberStatus, placement: 'top' }, textIcon)),
        contactPhoneNumber.type.fax && React.createElement(FaxOutlinedIcon, { fontSize: 'small', sx: { color: iconColor, mr: 1 } })));
};
